SJ.Sound = class {
  constructor(
    name,
    fileName,
    volume = 0.5,
    loop = false,
    autoPlay = true,
    onEndCallback = null,
    soundPropagationDistance = 0,
    x = null,
    y = null,
    earsPositionX,
    earsPositionY,
    afterLoad = null,
    multiPlay = false,
    playInterval = 0,
    translateX = 0,
    translateY = 0
  ) {
    if (
      soundPropagationDistance > 0 &&
      x &&
      y &&
      earsPositionX &&
      earsPositionY
    ) {
      this.x = x;
      this.y = y;

      this.earsPositionX = earsPositionX;
      this.earsPositionY = earsPositionY;

      this.soundPropagationDistance = soundPropagationDistance;
    }

    this.name = name;

    this.fileName = fileName;
    this.volume = volume;
    this.autoPlay = autoPlay;
    this.loop = loop;
    this.afterLoad = afterLoad;
    this.multiPlay = multiPlay;
    this.playIntervalTime = playInterval;

    this.translateX = translateX;
    this.translateY = translateY;

    this.playInterval = null;

    if (this.playIntervalTime > 0) this.loop = false;
  }

  load() {
    if (!SJ.IS_MOBILE)
      this.sound = loadSound(
        `skijump-js/sj-sounds/${this.fileName}`,
        () => {
          if (this.autoPlay) {
            this.play();
          }

          this.setVolume(this.volume, 0);
          this.setLoop(this.loop);

          // console.log(`Audio "${this.fileName}" loaded successfuly`);

          if (this.afterLoad) this.afterLoad();

          // this.sound.onended(onEndCallback);
        },
        () => {
          console.log(`Audio ${this.fileName} loading ERROR`);
        }
      );
  }

  destruct() {
    if (!SJ.IS_MOBILE) {
      window.clearInterval(this.playInterval);
      this.sound.stop();
      this.sound.dispose();
      this.sound = null;
    }
  }

  play() {
    if (this.sound) {
      if (this.sound.isPlaying() && !this.multiPlay) return;

      if (!this.playInterval && this.playIntervalTime > 0) {
        this.playInterval = window.setInterval(() => {
          this.play();
        }, this.playIntervalTime);

        // console.log(this.playInterval);
      } else {
        if (this.sound.isLoaded()) this.sound.play();
        else this.autoPlay = true;
      }

      // console.log(`Playing: ${this.fileName}`);
    } else if (!this.sound && !SJ.IS_MOBILE) {
      console.error(`Trying to play ${this.fileName}. Doesn't exist`);
    }
  }

  pause() {
    if (!SJ.IS_MOBILE) {
      this.sound.pause();

      if (this.autoPlay) this.autoPlay = false;

      window.clearInterval(this.playInterval);
      this.playInterval = null;
    }
  }

  stop() {
    if (!SJ.IS_MOBILE) {
      this.sound.stop();

      if (this.autoPlay) this.autoPlay = false;

      window.clearInterval(this.playInterval);
      this.playInterval = null;
    }
  }

  restart() {
    if (!SJ.IS_MOBILE) {
      this.stop();
      this.play();
    }
  }

  easyPlay(time = 0.5) {
    if (!SJ.IS_MOBILE) {
      const curVolume = this.volume;

      this.setVolume(0, 0);
      this.play();
      this.setVolume(curVolume, time);
    }
  }

  easyPause(time = 0.5) {
    if (!SJ.IS_MOBILE) {
      const curVolume = this.volume;
      this.setVolume(0, time);

      window.setTimeout(() => {
        this.pause();
        this.setVolume(curVolume);
      }, time * 1000);
    }
  }

  easyStop(time = 0.5) {
    if (!SJ.IS_MOBILE) {
      const curVolume = this.volume;
      this.setVolume(0, time);

      window.setTimeout(() => {
        this.stop();
        this.setVolume(curVolume);
      }, time * 1000);
    }
  }

  setVolume(newVolume, rampTime = 0) {
    if (!SJ.IS_MOBILE) {
      this.volume = newVolume;
      this.sound.setVolume(newVolume, rampTime);
    }
  }

  setPath(path) {
    if (!SJ.IS_MOBILE) this.sound.setPath(path);
  }

  setLoop(loop) {
    if (!SJ.IS_MOBILE) this.sound.setLoop(loop);
  }

  isPlaying() {
    if (!SJ.IS_MOBILE) return this.sound.isPlaying();
    else return false;
  }

  isLoaded() {
    if (!SJ.IS_MOBILE) return this.sound.isLoaded();
    else return false;
  }

  getEarsPosition() {
    let earsPos = {
      x: 0,
      y: 0,
    };

    if (
      typeof this.earsPositionX === 'string' &&
      typeof this.earsPositionY === 'string'
    ) {
      earsPos.x = Object.byString(SJ, this.earsPositionX);
      earsPos.y = Object.byString(SJ, this.earsPositionY);
      // earsPos.x = SJ[this.earsPositionX];
      // earsPos.y = SJ[this.earsPositionY];
    } else if (
      typeof this.earsPositionX === 'number' &&
      typeof this.earsPositionY === 'number'
    ) {
      earsPos.x = this.earsPositionX;
      earsPos.y = this.earsPositionY;
    }

    return earsPos;
  }

  getDistanceToEars() {
    const earsPos = this.getEarsPosition();

    const xPow = Math.pow(earsPos.x - this.x, 2);
    const yPow = Math.pow(earsPos.y - this.y, 2);

    const distanceToEars = Math.sqrt(xPow + yPow);

    return distanceToEars;
  }

  mapHearingDistance(distanceToEars) {
    // console.log(this.name);
    // console.log(this.soundPropagationDistance);
    // console.log(this.volume);

    if (this.soundPropagationDistance > 0 && this.volume >= 0) {
      // console.log(earsPosX, earsPosY);

      // console.log(`Distance to ears: ${distanceToEars}`);
      // console.log(`SPD: ${this.soundPropagationDistance}`);
      // console.log(`Volume: ${this.volume}`);

      let newVolume = map(
        distanceToEars,
        this.soundPropagationDistance,
        0,
        0,
        this.volume
      );

      if (newVolume < 0 || isNaN(newVolume)) newVolume = 0;

      // console.log(newVolume);
      this.sound.setVolume(newVolume, 0.1);
    }
  }

  mapStereoPanning(distanceToEars) {
    if (this.soundPropagationDistance > 0 && this.volume >= 0) {
      let newPanning = 0;
      let earsPos = this.getEarsPosition();

      if (this.x < earsPos.x) {
        newPanning = map(
          distanceToEars,
          this.soundPropagationDistance,
          0,
          -1.0,
          0
        );
      } else if (this.x > earsPos.x) {
        newPanning = map(
          distanceToEars,
          this.soundPropagationDistance,
          0,
          1.0,
          0
        );
      }

      // console.log(newPanning);

      if (newPanning <= 1.0 && newPanning >= -1.0) this.sound.pan(newPanning);
    }
  }

  _update(nx = null, ny = null) {
    if (this.sound) {
      // if(this.name === 'bird')
      //   console.log(nx, ny);

      let tmpX = this.x;
      let tmpY = this.y;

      this.x = nx || this.x;
      this.y = ny || this.y;

      this.x += this.translateX;
      this.y += this.translateY;

      const distanceToEars = this.getDistanceToEars();

      this.mapHearingDistance(distanceToEars);
      this.mapStereoPanning(distanceToEars);

      this.x = tmpX;
      this.y = tmpY;
    }
  }
};
